export default {
    moves: 'Κινήσεις',
    time: 'Χρόνος',
    score: 'Σκορ',
    settings: 'Ρυθμίσεις',
    sounds: 'Ήχος',
    autocomplete: 'Αυτόματη συμπλήρωση',
    leftHanded: 'Αριστερόχειρας',
    newDeal: 'Νέο Μοίρασμα',
    design: 'Προσαρμογή',
    easy: 'Εύκολο',
    medium: 'Μέτριο',
    hard: 'Δύσκολο',
    expert: 'Ειδικός',
    master: 'Εξπέρ',
    random: 'Τυχαίο',
    balanced: 'Ισορροπία',
    rulesKlondikeURL: 'https://solitaires.com/gr/articles/how-to-play-solitaire/',
    cardHighlight: 'Επισήμανση κάρτας',
    rulesSpiderURL: 'https://solitaires.com/gr/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/gr/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Αυτόματο παιχνίδι',
    noMagicNeeded: 'Δεν χρειάζεται Μαγικό Ραβδί—συνεχίστε το παιχνίδι μόνοι σας!',
    leaveFeedback: 'Αφήστε σχόλια',
    feedbackThankYou: 'Εκτιμούμε το σχόλιό σας!',
    feedbackError: 'Παρουσιάστηκε σφάλμα. Το μήνυμά σας δεν στάλθηκε.',
    thanksSubscribing: 'Ευχαριστούμε για την εγγραφή!',
    rulesPyramidURL: 'https://solitaires.com/gr/articles/how-to-play-pyramid-solitaire/',

    tutorialSkip: 'Παράλειψη',
    tutorialRestart: 'Ξεκίνησε ξανά',

    klondikeTutorialStep1: 'Στόχος σου είναι να μεταφέρεις όλες τις κάρτες στη βάση, ταξινομώντας κάθε σύμβολο με αύξουσα σειρά από τον Άσο μέχρι τον Ρήγα — όπως <span style="color: #F11F1F;">A♥, 2♥, 3♥</span> κ.λπ. Πάτησε σε μια κάρτα για να τη στείλεις εκεί!',
    klondikeTutorialStep2: 'Μπράβο! Συνέχισε να φτιάχνεις σειρές στη βάση.',
    klondikeTutorialStep3: 'Πολύ καλά! Μπορείς να μετακινείς κάρτες μεταξύ των στηλών — απλώς βάλε μια κάρτα πάνω σε μία που είναι κατά μία μεγαλύτερη και διαφορετικού χρώματος.',
    klondikeTutorialStep4: 'Μπορείς να μετακινήσεις μια ακολουθία αν η κάτω κάρτα είναι κατά μία μικρότερη και διαφορετικού χρώματος από αυτή που τη βάζεις.',
    klondikeTutorialStep5: 'Αν υπάρχει κενή στήλη στο ταμπλό, μπορείς να τοποθετήσεις μόνο έναν Ρήγα ή μια σειρά που ξεκινάει με Ρήγα.',
    klondikeTutorialStep6: 'Αν δεν έχεις άλλες κινήσεις, πάτησε στην τράπουλα για να ανοίξεις νέες κάρτες. Μπορείς να τις βάλεις στο ταμπλό ή στη βάση.',
    klondikeTutorialStep7: 'Ωραία! Τώρα συνέχισε μόνος σου.',
    klondikeTutorialStep8: 'Αν τελειώσει η τράπουλα, πάτησέ την για ανανέωση και συνέχισε να παίζεις。',
    klondikeTutorialStep9: 'Είσαι σχεδόν έτοιμος! Ολοκλήρωσε τις στοίβες στη βάση για να κερδίσεις το παιχνίδι.',

    spiderTutorialStep1: 'Στόχος σου είναι να μεταφέρεις όλες τις κάρτες στη βάση, δημιουργώντας φθίνουσες ακολουθίες από τον Ρήγα μέχρι τον Άσο στο ταμπλό. Πάτησε μια κάρτα για να αρχίσεις να χτίζεις την ακολουθία!',
    spiderTutorialStep2: 'Μπορείς να μετακινήσεις μια ακολουθία αν η κάτω κάρτα είναι έναν βαθμό μικρότερη από αυτή που την τοποθετείς. Πάτησέ την για να μετακινήσεις ολόκληρη τη στοίβα!',
    spiderTutorialStep3: 'Μπράβο! Συνέχισε να δημιουργείς την ακολουθία — μόλις ολοκληρωθεί, θα μεταφερθεί αυτόματα στη βάση.',
    spiderTutorialStep4: 'Αν δεν έχεις άλλες κινήσεις, πάτησε την τράπουλα για να μοιράσεις νέες κάρτες — μία σε κάθε στήλη.',
    spiderTutorialStep5: 'Καλή δουλειά! Τώρα είναι η σειρά σου — συνέχισε και ολοκλήρωσε το παιχνίδι!',

    freeCellTutorialStep1: 'Στόχος σου είναι να μεταφέρεις όλες τις κάρτες στη βάση, τοποθετώντας κάθε σύμβολο με αύξουσα σειρά από τον Άσο μέχρι τον Ρήγα — όπως A♠, 2♠, 3♠ κ.λπ. Πάτησε σε μια κάρτα για να τη στείλεις!',
    freeCellTutorialStep2: 'Μπορείς να μετακινήσεις κάρτες μεταξύ των στηλών — απλώς βάλε μια κάρτα πάνω σε μία που είναι κατά μία μεγαλύτερη και διαφορετικού χρώματος.',
    freeCellTutorialStep3: 'Μπορείς να μετακινήσεις μια σειρά αν η κάτω κάρτα είναι μικρότερη κατά μία και διαφορετικού χρώματος από την κάρτα πάνω στην οποία τη βάζεις. Θυμήσου: δεν μπορείς να μετακινήσεις περισσότερες κάρτες από τις κενές ελεύθερες θέσεις συν μία。',
    freeCellTutorialStep4: 'Μπορείς να τοποθετήσεις οποιαδήποτε μεμονωμένη κάρτα ή μια ακολουθία σε μια κενή στήλη του ταμπλό.',
    freeCellTutorialStep5: 'Οι ελεύθερες θέσεις είναι ειδικά σημεία για προσωρινή αποθήκευση καρτών. Κάθε μία μπορεί να κρατήσει μόνο μία κάρτα, την οποία μπορείς να επιστρέψεις στο ταμπλό ή στη βάση όταν χρειαστεί.',
    freeCellTutorialStep6: 'Τώρα είναι η σειρά σου! Χρησιμοποίησε όσα έμαθες και τελείωσε το παιχνίδι!',

    startTutorialPopupTitle: 'Καλώς ήρθες! Δοκίμασε μια σύντομη εκμάθηση και μάθε τα βασικά πριν ξεκινήσεις να παίζεις.',
    startTutorial: 'Ξεκίνα την εκμάθηση',
    skipTutorial: 'Παράλειψη',
};
